import React, { Component } from 'react';
import Icon from '@ant-design/icons';
import Style from './style';

const CloseSvg = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <rect x="19.999" y="18.5841" width="2.00105" height="26.2817" rx="1" transform="rotate(135 19.999 18.5841)" fill="currentColor"/>
        <rect x="1.41602" y="19.9989" width="2.00105" height="26.2817" rx="1" transform="rotate(-135 1.41602 19.9989)" fill="currentColor"/>
    </svg>
)

class CloseIcon extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        const ariaProps = this.props.ariaLabel
            ? { 'aria-label': this.props.ariaLabel }
            : { 'aria-hidden': 'true' };
        return (
            <Icon className={`cicon ${this.props.className||''}`} style={Object.assign({},Style,this.props.style)} component={CloseSvg} {...ariaProps} />
        )
    }
}
export default CloseIcon;
